export default {"src":"/_next/static/media/CART.29fc49c2.svg","height":18,"width":18};